import React from 'react';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
import Calculator from '../utils/calculator';

import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntCondition from '../utils/AntCondition';
import AntPopup from './AntPopup';
import AntEditForm from './old/AntEditForm';
import AntTabs from './AntTabs';
import AntErrorPanel from './AntErrorPanel';
import AntMessageBox from './AntMessageBox';
import AntConfig from '../utils/AntConfig';
import AntAuth from '../utils/AntAuth';
import AntLocalization from '../utils/AntLocalization';

export default class extends React.Component {
    constructor(props) {
        super(props);

        var tableName = this.props.table ? this.props.table : this.props.API ? this.props.API.entityName : '';
        this.config = new AntConfig(this.props.session, tableName);
        this.config.configFields(this.props.fields);

        this.state = {
            error: null,
            entityDisplay: this.API && this.API.entityDisplay ? this.API.entityDisplay : this.props.entityDisplay ? this.props.entityDisplay : '',
            tabHeaders: [],
            tabFooters: [],
            isValidated: false,
            formData: {},
            oldData: { edit: undefined }
        };

        this.API = this.props.API;

        this.show = this.show.bind(this);
        this.showById = this.showById.bind(this);
        this.load = this.load.bind(this);
        this.refresh = this.refresh.bind(this);
        this.setError = this.setError.bind(this);
        this.getForm = this.getForm.bind(this);
        // this.validate = this.validate.bind(this);

        this.initHeader = this.initHeader.bind(this);
        this.initFooter = this.initFooter.bind(this);
        this.initTabs = this.initTabs.bind(this);
        this.initSize = this.initSize.bind(this);

        this.getValidData = this.getValidData.bind(this);
        this.getChangedFields = this.getChangedFields.bind(this);
        this.getId = this.getId.bind(this);
        this.getChecksum = this.getChecksum.bind(this);
        this.getFormData = this.getFormData.bind(this);
        this.isDisableForm = this.isDisableForm.bind(this);

        this.resetUI = this.resetUI.bind(this);
        this.resetVisibility = this.resetVisibility.bind(this);
        this.resetDisabled = this.resetDisabled.bind(this);
        this.resetDefaultValue = this.resetDefaultValue.bind(this);
        this.resetSize = this.resetSize.bind(this);

        this.showAlert = this.showAlert.bind(this);

        this.setField = this.setField.bind(this);
        this.getField = this.getField.bind(this);
        this.save = this.save.bind(this);

        this.onFieldDataChanged = this.onFieldDataChanged.bind(this);
        this.onTabChanged = this.onTabChanged.bind(this);
        this.onRenderTabContent = this.onRenderTabContent.bind(this);

        this.isShowing = this.isShowing.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);

        this.beginUpdate = this.beginUpdate.bind(this);
        this.endUpdate = this.endUpdate.bind(this);
    }

    beginUpdate() {
        if (this.popup) this.popup.beginUpdate();
        if (this.headerForm) this.headerForm.beginUpdate();
        if (this.footerForm) this.footerForm.beginUpdate();
        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.beginUpdate();
        }

        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.beginUpdate();
        }
    }

    endUpdate() {
        if (this.headerForm) this.headerForm.endUpdate();
        if (this.footerForm) this.footerForm.endUpdate();
        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.endUpdate();
        }

        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.endUpdate();
        }
        if (this.popup) this.popup.endUpdate();
    }

    async showAlert(title, content, buttons, onClosedCallback) {
        if (this.msgBox) this.msgBox.show(title, content, buttons, onClosedCallback);
    }

    isShowing() {
        return this.popup && this.popup.isShowing();
    }

    getForm() {
        if (this.headerForm) return this.headerForm;
        if (this.footerForm) return this.headerForm;
    }

    getId() {
        return this.state.oldData ? this.state.oldData.id : null;
    }
    getChecksum() {
        return this.state.oldData ? this.state.oldData.checksum : null;
    }

    getFormData() {
        return this.state.formData;
    }

    async showById(id) {
        if (!id) return;
        return this.show({ id: id });
    }

    async show(defaultObj) {
        var that = this;

        return new Promise(async (resolve) => {
            if (that.popup) {
                that.beginUpdate();

                that.setState(
                    (state) => {
                        state.error = null;
                        state.loaded = false;

                        Object.keys(state.formData).forEach((key) => {
                            delete state.formData[key];
                        });
                        that.setDefaultValues(state.formData);

                        var obj = { ...defaultObj };
                        obj = JSON.parse(stringify(obj));
                        Object.keys(obj).forEach((key) => {
                            state.formData[key] = obj[key];
                        });

                        state.defaultObj = JSON.parse(stringify({ ...defaultObj }));
                        return state;
                    },
                    async () => {
                        that.resetSize();
                        that.endUpdate();

                        that.beginUpdate();
                        that.popup.show(async () => {
                            await that.load();
                            that.resetSize();
                            if (resolve) resolve(that.state.formData);
                        });
                    }
                );
            }
        });
    }

    async load() {
        if (!this.state.loaded) {
            Object.keys(this.state.formData).forEach((key) => {
                delete this.state.formData[key];
            });
            this.setDefaultValues(this.state.formData);

            var obj = { ...this.state.defaultObj };
            obj = JSON.parse(stringify(obj));
            Object.keys(obj).forEach((key) => {
                this.state.formData[key] = obj[key];
            });
            this.state.defaultObj = JSON.parse(stringify({ ...obj }));

            if (this.headerForm && this.headerForm.loadByObj) {
                this.state.loaded = true;
                obj = await this.headerForm.loadByObj(obj);
            }

            if (this.footerForm && this.footerForm.loadByObj) {
                this.state.loaded = true;
                obj = await this.footerForm.loadByObj(obj);
            }

            for (let i = 0; i < this.state.tabHeaders.length; i++) {
                const header = this.state.tabHeaders[i];
                if (header && header.ref) {
                    header.ref.onError = this.setError;
                    obj = await header.ref.loadByObj(obj);
                    this.state.loaded = true;
                }
            }

            for (let i = 0; i < this.state.tabFooters.length; i++) {
                const footer = this.state.tabFooters[i];
                if (footer && footer.ref) {
                    footer.ref.onError = this.setError;
                    obj = await footer.ref.loadByObj(obj);
                    this.state.loaded = true;
                }
            }

            Object.keys(this.state.defaultObj).forEach((key) => {
                obj[key] = this.state.defaultObj[key];
            });

            this.setState((state) => {
                state.error = null;

                Object.keys(state.formData).forEach(function (key) {
                    delete state.formData[key];
                });

                Object.keys(obj).forEach(function (key) {
                    state.formData[key] = obj[key];
                });
                state.oldData = { ...JSON.parse(stringify({ ...obj })), edit: undefined };
                return state;
            });
        }
    }

    async onShowing() {
        await this.load();
        await this.resetUI(true);
    }
    async onShown() {
        await this.load();
        await this.resetUI(true);
        this.resetSize();
        setTimeout(this.resetSize, 300);
        this.endUpdate();
    }

    async setField(field, value, raiseEvent) {
        if (this.headerForm && this.headerForm.setField) await this.headerForm.setField(field, value, raiseEvent);

        if (this.footerForm && this.footerForm.setField) await this.footerForm.setField(field, value, raiseEvent);

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) await header.ref.setField(field, value, raiseEvent);
        }

        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) await footer.ref.setField(field, value, raiseEvent);
        }
    }

    getField(field) {
        return this.state.formData[field];
    }

    async setError(content, errors) {
        if (!content && (this.state.error === null || this.state.error === undefined)) return;

        if (errors == 'TypeError: Failed to fetch') errors = { vi: 'Không thể kết nối đến hệ thống !', en: 'Can not connect to system !', fr: 'Impossible de se connecter au système !', es: '¡No se puede conectar al sistema!', id: 'Tidak dapat terhubung ke sistem!', ja: 'システムに接続できません！', zh: '无法连接到系统！', ko: '시스템에 연결할 수 없습니다!', hi: 'सिस्टम से कनेक्ट नहीं हो सकता!', ar: 'لا يمكن الاتصال بالنظام!' };

        var values = errors === undefined || errors === null ? [] : errors instanceof Array ? errors : [errors];

        content = values.length === 1 ? values[0] : content;

        this.setState(
            {
                error: content
                    ? {
                          text: String(content),
                          values: values
                      }
                    : null
            },
            () => {
                if (this.props.onError) this.props.onError(content, errors);
            }
        );
    }

    isDisableForm() {
        if (
            this.state &&
            this.state.formData &&
            this.state.formData.edit &&
            this.state.formData.edit.always_editable_fields instanceof Array &&
            this.state.formData.edit.always_editable_fields.length > 0
        )
            return false;

        var disabled =
            this.props.disabled ||
            !this.state ||
            !this.state.formData ||
            !this.state.formData.id ||
            !this.state.formData.edit ||
            this.state.formData.edit.errors ||
            !this.state.formData.edit.isEditable ||
            (this.state.formData.edit.editable_fields &&
                this.state.formData.edit.editable_fields instanceof Array &&
                this.state.formData.edit.editable_fields.length <= 0);

        if (disabled) return true;

        return false;
    }

    async refresh() {
        var isEditable = !this.isDisableForm();

        var errors =
            this.state.formData && this.state.formData.edit && this.state.formData.edit.errors && this.state.formData.edit.errors instanceof Array
                ? this.state.formData.edit.errors
                : [];

        if (this.popup)
            this.popup.resetWidgets(
                isEditable
                    ? [
                          {
                              id: 'btnSave',
                              type: 'button',
                              icon: 'save',
                              text: { vi: 'Cập nhật', en: 'Update', fr: 'Mettre à jour', es: 'Actualizar', id: 'Perbarui', ja: '更新', zh: '更新', ko: '업데이트', hi: 'अपडेट करें', ar: 'تحديث' },
                              waiting_text: { vi: 'Chờ xử lý', en: 'Waiting...', fr: 'En attente', es: 'Pendiente', id: 'Tertunda', ja: '保留中', zh: '待处理', ko: '보류 중', hi: 'लंबित', ar: 'معلق' },
                              width: 130
                          }
                      ]
                    : []
            );

        if (isEditable) this.setError(null);
        else {
            let strEnd = AntLocalization.translateText({ vi: 'Không thể cập nhật thông tin !', en: 'Can not update data !', fr: 'Impossible de mettre à jour !', es: '¡No se puede actualizar!', id: 'Tidak dapat memperbarui!', ja: '更新できません！', zh: '无法更新！', ko: '업데이트 불가!', hi: 'अपडेट नहीं कर सकते!', ar: 'لا يمكن التحديث!' });
            this.setError(strEnd, errors);
        }
    }

    // async validate() {
    //     this.state.isValidated = true;
    //     var isOK = true;

    //     var headerValid = await this.headerForm.validate();
    //     if (!headerValid) isOK = false;

    //     var footerValid = await this.footerForm.validate();
    //     if (!footerValid) isOK = false;

    //     for (let i = 0; i < this.state.tabHeaders.length; i++) {
    //         const header = this.state.tabHeaders[i];
    //         if (header && header.ref) {
    //             var isValid = await header.ref.validate();
    //             if (!isValid) isOK = false;
    //         }
    //     }

    //     for (let i = 0; i < this.state.tabFooters.length; i++) {
    //         const footer = this.state.tabFooters[i];
    //         if (footer && footer.ref) {
    //             var isValid = await footer.ref.validate();
    //             if (!isValid) isOK = false;
    //         }
    //     }

    //     return isOK;
    // }

    async getValidData() {
        var that = this;

        this.state.isValidated = true;

        var isValid = true;

        if (this.headerForm && this.headerForm.validate) isValid = await this.headerForm.validate();

        if (this.footerForm && this.footerForm.validate) isValid = isValid && (await this.footerForm.validate());

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) isValid = isValid && (await header.ref.validate());
        }

        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) isValid = isValid && (await footer.ref.validate());
        }

        if (!isValid) return null;

        var obj = { ...this.state.formData };

        if (obj && this.props.postFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = this.props.postFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (!found) obj[k] = undefined;
                else {
                    this.props.postFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var rawField = field.field;
                            var postField = field.alias;
                            if (rawField === k) {
                                obj[postField] = obj[rawField];
                                obj[k] = undefined;
                            }
                        }
                    });
                }
            });

        return obj;
    }

    getChangedFields() {
        var obj = {};
        var formData = this.state.formData;
        var oldData = this.state.oldData;
        var edit = this.state.formData.edit;
        var that = this;

        Object.keys(formData).forEach(function (fieldName) {
            if (formData[fieldName] != edit && formData[fieldName] != oldData && formData[fieldName] != oldData[fieldName])
                obj[fieldName] = formData[fieldName];
        });

        if (obj && this.props.viewOnlyFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = this.props.viewOnlyFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (found) obj[k] = undefined;
            });

        if (obj && this.props.postFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = this.props.postFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (!found) obj[k] = undefined;
            });

        return obj;
    }

    async onAction(button) {
        var close = false;

        if (button && button.id == 'btnSave') close = await this.save();

        if (!close && this.props.onAction) close = await this.props.onAction(button);

        if (close && this.props.onSaved) this.props.onSaved(button);

        return close;
    }

    async save() {
        this.setError(null);

        var obj = await this.getValidData();
        if (!obj || Object.keys(obj).length <= 0) return false;

        obj = await this.getChangedFields();
        if (!obj || Object.keys(obj).length <= 0) return true;

        if (this.props.onSaving) obj = this.props.onSaving(this.state.formData, obj);
        if (!obj || Object.keys(obj).length === 0) return true;

        var errors = [];
        var errorContent = null;
        var result = await this.API.postUpdateValidation(
            {
                id: this.getId(),
                checksum: this.getChecksum()
            },
            obj
        );
        errors = this.config.translateErrors(result);
        errorContent = errors.length > 0 ? errors[0] : null;

        if (errors.length <= 0) {
            result = await this.API.postUpdate(
                {
                    id: this.getId(),
                    checksum: this.getChecksum()
                },
                obj
            );
            if (!result || result.error || !result.data || !result.data.updated) {
                errors = this.config.translateErrors(result);
                errorContent = errors.length > 0 ? errors[0] : null;
            }
        }

        if (errors.length > 0) {
            if (!errorContent) errorContent = 'Không thể cập nhật thông tin !';
            this.setError(errorContent, errors);
            if (this.props.onError) this.props.onError(errorContent, errors);
            else if (this.onError) this.onError(errorContent, errors);
            return false;
        } else {
            if (this.props.onSaved) this.props.onSaved(result.data);

            var history = this.config && this.config.session ? this.config.session.history : null;

            if (history && this.props.navigateLink && result.data) {
                var value;
                var link;

                var that = this;
                if (this.props.navigateLink instanceof Array) {
                    this.props.navigateLink.forEach((l) => {
                        if (l && l.link) {
                            if (l.when && typeof l.when === 'object') {
                                var isValid = AntCondition.isValid(that.state.formData, {
                                    when: l.when,
                                    whenType: l.whenType
                                });
                                if (!isValid) return;
                            }
                            value = l.field ? result.data[l.field] : result.data.code;
                            link = String(l.link);
                        }
                    });
                } else {
                    value = this.props.navigateField ? result.data[this.props.navigateField] : result.data.code;
                    link = String(this.props.navigateLink);
                }
                if (link && value !== undefined && value !== null) {
                    if (!link.startsWith('/')) link = '/' + link;
                    if (!link.endsWith('/')) link = link + '/';
                    link = link + value;
                    history.push(link);
                }
            }
        }
        return true;
    }

    async updateRowToMain(rowDatas, col) {
        var ar = [];
        if (typeof col.updateToMain === 'object') ar.push(col.updateToMain);
        if (col.updateToMain instanceof Array) ar.push(...col.updateToMain);

        for (let i = 0; i < ar.length; i++) {
            var rule = ar[i];

            if (rule && rule.target) {
                var targetField = rule.target;
                var calcType = rule.type;
                var targetValue = null;
                if (calcType === 'SUM') {
                    if (rule.cellFormula instanceof Array) {
                        var fm = rule.cellFormula[0];
                        var defaultNullValue =
                            rule.cellFormula[1] !== undefined && rule.cellFormula[1] !== null && typeof rule.cellFormula[1] === 'number'
                                ? rule.cellFormula[1]
                                : 0;

                        targetValue = rowDatas.reduce((total, current) => {
                            return total + Calculator.execNum(current, fm, defaultNullValue);
                        }, 0);
                    } else {
                        targetValue = rowDatas.reduce((total, current) => {
                            return total + parseFloat(current[col.dataField]);
                        }, 0);
                    }

                    await this.setField(targetField, targetValue);
                }
            }
        }
    }

    onRenderTabContent(tabName) {
        var that = this;
        if (this.props.tabs instanceof Array) {
            for (let i = 0; i < this.props.tabs.length; i++) {
                const tab = this.props.tabs[i];

                if (tab.name === tabName || (!tab.name && String(i) === tabName)) {
                    var isVisible = AntCondition.isVisible(this.state.formData, tab);
                    if (isVisible) {
                        var tabHeader = tab.header;
                        var tabFooter = tab.footer;
                        if (tabHeader) tabHeader = JSON.parse(stringify(tabHeader));
                        if (tabFooter) tabFooter = JSON.parse(stringify(tabFooter));

                        var isVisibleTabHeader = tabHeader && AntCondition.isVisible(this.state.formData, tabHeader);
                        var isVisibleTabFooter = tabFooter && AntCondition.isVisible(this.state.formData, tabFooter);

                        var header = null;
                        var footer = null;

                        if (tabHeader) {
                            var headerName = tabHeader.name ? tabHeader.name : tabName;
                            header = this.state.tabHeaders.find((r) => r.name === headerName);
                            if (!header) {
                                header = {
                                    tabName: tabName,
                                    name: headerName,
                                    props: tabHeader
                                };
                                this.state.tabHeaders.push(header);
                            }
                        }

                        if (tabFooter) {
                            var footerName = tabFooter.name ? tabFooter.name : tabName;
                            footer = this.state.tabFooters.find((r) => r.name === footerName);
                            if (!footer) {
                                footer = {
                                    tabName: tabName,
                                    name: footerName,
                                    props: tabFooter
                                };
                                this.state.tabFooters.push(footer);
                            }
                        }

                        return (
                            <React.Fragment>
                                {isVisibleTabHeader && (
                                    <AntEditForm
                                        ref={(ref) => {
                                            if (header) header.ref = ref;
                                        }}
                                        API={tabHeader.API ? tabHeader.API : this.props.API}
                                        session={this.props.session}
                                        table={tabHeader.table}
                                        formData={this.state.formData}
                                        labelLocation={tabHeader.labelLocation}
                                        alignItemLabelsInAllGroups={tabHeader.alignItemLabelsInAllGroups}
                                        colCount={tabHeader.colCount !== undefined ? tabHeader.colCount : 1}
                                        colCountDefault={tabHeader ? tabHeader.colCountDefault : undefined}
                                        prepare={false}
                                        disabled={tabHeader && tabHeader.disabled !== undefined ? tabHeader.disabled : undefined}
                                        fields={tabHeader.fields}
                                        items={tabHeader.items}
                                        isSearching={
                                            tabHeader && tabHeader.isSearching !== undefined
                                                ? tabHeader.isSearching
                                                : this.props.isSearching !== undefined
                                                ? this.props.isSearching
                                                : true
                                        }
                                        postFields={tabHeader.postFields}
                                        onFieldDataChanged={this.onFieldDataChanged}
                                    />
                                )}

                                {isVisibleTabFooter && (
                                    <AntEditForm
                                        ref={(ref) => {
                                            if (footer) footer.ref = ref;
                                        }}
                                        API={tabFooter.API ? tabFooter.API : this.props.API}
                                        session={this.props.session}
                                        table={tabFooter.table}
                                        formData={this.state.formData}
                                        alignItemLabelsInAllGroups={tabFooter.alignItemLabelsInAllGroups}
                                        labelLocation={tabFooter.labelLocation}
                                        colCount={tabFooter.colCount !== undefined ? tabFooter.colCount : 1}
                                        colCountDefault={tabFooter ? tabFooter.colCountDefault : undefined}
                                        prepare={false}
                                        disabled={tabFooter && tabFooter.disabled !== undefined ? tabFooter.disabled : undefined}
                                        fields={tabFooter.fields}
                                        items={tabFooter.items}
                                        isSearching={
                                            tabFooter && tabFooter.isSearching !== undefined
                                                ? tabFooter.isSearching
                                                : this.props.isSearching !== undefined
                                                ? this.props.isSearching
                                                : true
                                        }
                                        postFields={tabFooter.postFields}
                                        onFieldDataChanged={this.onFieldDataChanged}
                                    />
                                )}
                            </React.Fragment>
                        );
                    }
                }
            }
        }

        return <div></div>;
    }

    async onTabChanged(e) {
        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.tabName === e.selectedName) {
                if (this.state.isValidated) await this.getValidData();
            }
        }
        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.tabName === e.selectedName) {
                if (this.state.isValidated) await this.getValidData();
            }
        }
    }

    onFieldDataChanged(e) {
        this.setState(
            (state) => {
                Object.keys(e).forEach((key) => {
                    state.formData[key] = e[key];
                });
            },
            () => {
                this.beginUpdate();
                this.resetUI(true);

                if (this.props.onFieldDataChanged) this.props.onFieldDataChanged(e);

                this.endUpdate();
            }
        );
    }

    async resetUI(withoutUpdate) {
        if (!withoutUpdate) this.beginUpdate();
        await this.resetDefaultValue();
        await this.resetVisibility();
        await this.resetDisabled();
        await this.resetSize();
        if (!withoutUpdate) this.endUpdate();
    }

    resetVisibility() {
        if (this.headerForm) this.headerForm.resetVisibility();
        if (this.footerForm) this.footerForm.resetVisibility();
        if (this.tabs) this.tabs.resetVisibility();

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.resetVisibility();
        }
        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.resetVisibility();
        }
    }

    resetDisabled() {
        if (this.headerForm) this.headerForm.resetDisabled();
        if (this.footerForm) this.footerForm.resetDisabled();

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.resetDisabled();
        }
        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.resetDisabled();
        }
    }

    resetSize() {
        this.initHeader();
        this.initFooter();
        this.initTabs();
        this.initSize();
        this.initSize();

        if (this.headerForm) this.headerForm.updateDimensions();
        if (this.footerForm) this.footerForm.updateDimensions();

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.updateDimensions();
        }
        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.updateDimensions();
        }

        if (this.popup) this.popup.setSize(this.state.height, this.state.width);

        // this.forceUpdate();
    }

    resetDefaultValue() {
        if (this.headerForm) this.headerForm.resetDefaultValue();
        if (this.footerForm) this.footerForm.resetDefaultValue();

        for (let i = 0; i < this.state.tabHeaders.length; i++) {
            const header = this.state.tabHeaders[i];
            if (header && header.ref) header.ref.resetDefaultValue();
        }
        for (let i = 0; i < this.state.tabFooters.length; i++) {
            const footer = this.state.tabFooters[i];
            if (footer && footer.ref) footer.ref.resetDefaultValue();
        }
    }

    // resetUI(withoutUpdate) {
    //     if (this.headerForm) this.headerForm.resetUI(withoutUpdate);
    //     if (this.footerForm) this.footerForm.resetUI();

    //     for (let i = 0; i < this.state.tabHeaders.length; i++) {
    //         const header = this.state.tabHeaders[i];
    //         if (header && header.ref) header.ref.resetUI(withoutUpdate);
    //     }
    //     for (let i = 0; i < this.state.tabFooters.length; i++) {
    //         const footer = this.state.tabFooters[i];
    //         if (footer && footer.ref) footer.ref.resetUI(withoutUpdate);
    //     }
    // }

    setDefaultValues(formData) {
        var obj = {};

        if (this.props.header && this.props.header.items instanceof Array) {
            this.props.header.items.forEach((item) => {
                if (item && item.dataField && item.default !== undefined) AntCondition.setDefault(formData, item);
            });
        }
        if (this.props.footer && this.props.footer.items instanceof Array) {
            this.props.footer.items.forEach((item) => {
                if (item && item.dataField && item.default !== undefined) AntCondition.setDefault(formData, item);
            });
        }
        return obj;
    }

    initHeader() {
        var isVisibleHeader = this.props.header && AntCondition.isVisible(this.state.formData, this.props.header);

        var headerColCount = undefined;
        if (this.props.header) {
            headerColCount = AntCondition.getValue(this.state.formData, this.props.header.colCount);
            if (headerColCount === undefined) headerColCount = this.props.header.colCountDefault ? this.props.header.colCountDefault : 1;
        }
        var headerItems = this.props.header && this.props.header.items instanceof Array ? this.props.header.items : [];
        headerItems = JSON.parse(stringify(headerItems));
        headerItems = headerItems.filter((item) => {
            return AntCondition.isVisible(this.state.formData, item);
        });

        var that = this;
        var sumSpan = headerItems.reduce((total, current) => {
            var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
            if (colSpan === undefined) colSpan = current.colSpanDefault;

            return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
        }, 0);

        var headerLineCount = Math.ceil(sumSpan / headerColCount);
        var headerHeight = 0;
        if (isVisibleHeader && headerLineCount > 0) {
            headerHeight = headerLineCount * 36 + (headerLineCount - 1) * 10;
            headerHeight += headerItems.reduce((total, current) => {
                return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
            }, 0);
        }

        this.state.headerItems = headerItems;
        this.state.headerLineCount = headerLineCount;
        this.state.headerHeight = headerHeight;
        this.state.headerVisible = isVisibleHeader;
    }

    initFooter() {
        var isVisibleFooter = this.props.footer && AntCondition.isVisible(this.state.formData, this.props.footer);

        var footerColCount = undefined;
        if (this.props.footer) {
            footerColCount = AntCondition.getValue(this.state.formData, this.props.footer.colCount);
            if (footerColCount === undefined) footerColCount = this.props.footer.colCountDefault ? this.props.footer.colCountDefault : 1;
        }
        var footerItems = this.props.footer && this.props.footer.items instanceof Array ? this.props.footer.items : [];
        footerItems = JSON.parse(stringify(footerItems));
        footerItems = footerItems.filter((item) => {
            return AntCondition.isVisible(this.state.formData, item);
        });

        var that = this;
        var sumSpan = footerItems.reduce((total, current) => {
            var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
            if (colSpan === undefined) colSpan = current.colSpanDefault;

            return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
        }, 0);

        var footerLineCount = Math.ceil(sumSpan / footerColCount);
        var footerHeight = 0;
        if (isVisibleFooter && footerLineCount > 0) {
            footerHeight = footerLineCount * 36 + (footerLineCount - 1) * 10;
            footerHeight += footerItems.reduce((total, current) => {
                return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
            }, 0);
        }

        this.state.footerItems = footerItems;
        this.state.footerLineCount = footerLineCount;
        this.state.footerHeight = footerHeight;
        this.state.footerVisible = isVisibleFooter;
    }

    initTabs() {
        var tabs = [];
        if (this.props.tabs instanceof Array) {
            tabs = this.props.tabs.filter((tab) => {
                return AntCondition.isVisible(that.state.formData, tab);
            });
            tabs = tabs.forEach((tab) => {
                var isVisibleHeader = tab.header && AntCondition.isVisible(this.state.formData, tab.header);

                var headerColCount = undefined;
                if (tab.header) {
                    headerColCount = AntCondition.getValue(that.state.formData, tab.header.colCount);
                    if (headerColCount === undefined) headerColCount = tab.header.colCountDefault ? tab.header.colCountDefault : 1;
                }
                var headerItems = tab.header && tab.header.items instanceof Array ? tab.header.items : [];
                headerItems = JSON.parse(stringify(headerItems));
                headerItems = headerItems.filter((item) => {
                    return AntCondition.isVisible(this.state.formData, item);
                });

                var that = this;
                var sumSpan = headerItems.reduce((total, current) => {
                    var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
                    if (colSpan === undefined) colSpan = current.colSpanDefault;

                    return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
                }, 0);

                var headerLineCount = Math.ceil(sumSpan / headerColCount);
                var headerHeight = 0;
                if (isVisibleHeader && headerLineCount > 0) {
                    headerHeight = headerLineCount * 36 + (headerLineCount - 1) * 10;
                    headerHeight += headerItems.reduce((total, current) => {
                        return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
                    }, 0);
                }

                tab.headerItems = headerItems;
                tab.headerLineCount = headerLineCount;
                tab.headerHeight = headerHeight;
                tab.headerVisible = isVisibleHeader;

                var isVisibleFooter = tab.footer && AntCondition.isVisible(this.state.formData, tab.footer);

                var footerColCount = undefined;
                if (tab.footer) {
                    footerColCount = AntCondition.getValue(this.state.formData, tab.footer.colCount);
                    if (footerColCount === undefined) footerColCount = tab.footer.colCountDefault ? tab.footer.colCountDefault : 1;
                }
                var footerItems = tab.footer && tab.footer.items instanceof Array ? tab.footer.items : [];
                footerItems = JSON.parse(stringify(footerItems));
                footerItems = footerItems.filter((item) => {
                    return AntCondition.isVisible(this.state.formData, item);
                });

                var that = this;
                var sumSpan = footerItems.reduce((total, current) => {
                    var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
                    if (colSpan === undefined) colSpan = current.colSpanDefault;

                    return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
                }, 0);

                var footerLineCount = Math.ceil(sumSpan / footerColCount);
                var footerHeight = 0;
                if (isVisibleFooter && footerLineCount > 0) {
                    footerHeight = footerLineCount * 36 + (footerLineCount - 1) * 10;
                    footerHeight += footerItems.reduce((total, current) => {
                        return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
                    }, 0);
                }

                tab.footerItems = footerItems;
                tab.footerLineCount = footerLineCount;
                tab.footerHeight = footerHeight;
                tab.footerVisible = isVisibleFooter;
            });
        }
        var isVisibleTabs = tabs.length > 0;

        this.state.tabs = tabs;
        this.state.tabsVisible = isVisibleTabs;
    }

    initSize() {
        var minHeight;

        if (this.props.height instanceof Array) {
            for (let i = 0; i < this.props.height.length; i++) {
                const e = this.props.height[i];
                if (e && typeof e.when === 'object' && e.when !== null && e.value !== undefined) {
                    var isValid = AntCondition.isValid(this.state.formData, {
                        when: e.when,
                        whenType: e.whenType
                    });
                    if (isValid) {
                        minHeight = parseFloat(e.value);
                        break;
                    }
                }
            }
        } else if (typeof this.props.height === 'number') minHeight = parseFloat(this.props.height);

        var height = 0;
        if (this.state.tabsVisible)
            this.state.tabs.forEach((tab) => {
                height += tab.headerHeight ? parseFloat(tab.headerHeight) : 0;
                height += tab.footerHeight ? parseFloat(tab.footerHeight) : 0;
            });

        height += this.state.headerHeight ? parseFloat(this.state.headerHeight) : 0;
        height += this.state.searchHeight ? parseFloat(this.state.searchHeight) : 0;
        height += this.state.footerHeight ? parseFloat(this.state.footerHeight) : 0;
        height += 10 + 46 + 20 + 47;
        height += 10;

        if (minHeight && height < minHeight) height = minHeight;

        var width = AntCondition.getValue(this.state.formData, this.props.width);
        if (width === undefined) width = this.props.widthDefault;
        if (width === undefined) width = 600;

        this.state.width = width;
        this.state.height = height;
    }

    render() {
        this.initHeader();
        this.initFooter();
        this.initTabs();
        this.initSize();

        return (
            <React.Fragment>
                <AntPopup
                    ref={(ref) => {
                        this.popup = ref;
                    }}
                    session={this.props.session}
                    isGray={true}
                    height={parseInt(this.state.height)}
                    deferRendering={true}
                    // height={this.state.error ? parseInt(height) + 40 : parseInt(height)}
                    width={this.state.width}
                    autoHeight={true}
                    autoWidth={true}
                    title={
                        this.props.title
                            ? AntLocalization.translateText(this.props.title)
                            : `${AntLocalization.translateText({ vi: 'Chỉnh sửa', en: 'Edit', fr: 'Modifier', es: 'Editar', id: 'Edit', ja: '編集', zh: '编辑', ko: '편집', hi: 'संपादित करें', ar: 'تعديل' })} ${this.state.entityDisplay}`
                    }
                    onAction={this.onAction.bind(this)}
                    onShown={this.onShown.bind(this)}
                    onShowing={this.onShowing.bind(this)}
                    onClosed={this.props.onClosed}
                    name={`ant-voucher-edit-${this.API.entityName}`}
                    errors={this.state.error ? this.state.error.values : undefined}
                    errorText={this.state.error ? this.state.error.text : undefined}
                    separateErrorLine={this.props.separateErrorLine}
                    widgets={[
                        {
                            id: 'btnSave',
                            type: 'button',
                            icon: 'save',
                            text: { vi: 'Cập nhật', en: 'Update', fr: 'Mettre à jour', es: 'Actualizar', id: 'Perbarui', ja: '更新', zh: '更新', ko: '업데이트', hi: 'अपडेट करें', ar: 'تحديث' },
                            waiting_text: { vi: 'Chờ xử lý', en: 'Waiting...', fr: 'En attente', es: 'Pendiente', id: 'Tertunda', ja: '保留中', zh: '待处理', ko: '보류 중', hi: 'लंबित', ar: 'معلق' },
                            width: 130
                        }
                    ]}
                >
                    {/* {this.state.error && (
                        <BoxItem baseSize={40}>
                            <AntErrorPanel
                                errors={this.state.error.values}
                                id={`ant-voucher-edit-error-${this.API.entityName}`}
                                text={this.state.error.text}
                            />
                        </BoxItem>
                    )} */}

                    <Box direction="col" width="100%" height="100%">
                        {this.state.headerVisible && (
                            <BoxItem baseSize={this.state.headerHeight}>
                                <AntEditForm
                                    ref={(ref) => {
                                        this.headerForm = ref;
                                    }}
                                    session={this.props.session}
                                    table={this.props.header ? this.props.header.table : this.props.table}
                                    formData={this.state.formData}
                                    API={this.props.header && this.props.header.API ? this.props.header.API : this.props.API}
                                    labelLocation={this.props.header ? this.props.header.labelLocation : undefined}
                                    alignItemLabelsInAllGroups={this.props.header ? this.props.header.alignItemLabelsInAllGroups : undefined}
                                    colCount={this.props.header ? this.props.header.colCount : 1}
                                    colCountDefault={this.props.header ? this.props.header.colCountDefault : undefined}
                                    // prepare={true}
                                    disabled={this.props.header && this.props.header.disabled !== undefined ? this.props.header.disabled : undefined}
                                    fields={this.props.header ? this.props.header.fields : []}
                                    items={this.state.headerItems}
                                    postFields={this.props.header ? this.props.header.postFields : undefined}
                                    onFieldDataChanged={this.onFieldDataChanged}
                                    onError={this.setError}
                                />
                            </BoxItem>
                        )}
                        {this.state.headerVisible && this.state.tabsVisible && (
                            <BoxItem baseSize={10}>
                                <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />
                            </BoxItem>
                        )}

                        {this.state.tabsVisible && (
                            <BoxItem ratio={1} height={'100%'}>
                                <AntTabs
                                    ref={(ref) => {
                                        this.tabs = ref;
                                    }}
                                    tabs={this.state.tabs}
                                    rawTabs={this.props.tabs}
                                    formData={this.state.formData}
                                    height={'100%'}
                                    tabStyle={this.props.tabStyle}
                                    isH6={this.props.isH6 !== undefined ? this.props.isH6 : true}
                                    isH5={this.props.isH5 !== undefined ? this.props.isH5 : false}
                                    isH4={this.props.isH4}
                                    collapsible={this.props.collapsible !== undefined ? this.props.collapsible : false}
                                    multiple={this.props.multiple !== undefined ? this.props.multiple : false}
                                    onRenderTabContent={this.onRenderTabContent}
                                    onTabChanged={this.onTabChanged}
                                />
                            </BoxItem>
                        )}
                        {this.state.footerVisible && this.state.tabsVisible && (!this.props.footer || !this.props.footer.noSeparator) && (
                            <BoxItem baseSize={30}>
                                <p style={{ marginBlockStart: '0px', marginBlockEnd: '30px' }} />
                            </BoxItem>
                        )}

                        {this.state.footerVisible && (
                            <BoxItem baseSize={this.state.footerHeight}>
                                <AntEditForm
                                    ref={(ref) => {
                                        this.footerForm = ref;
                                    }}
                                    session={this.props.session}
                                    table={this.props.footer ? this.props.footer.table : this.props.table}
                                    formData={this.state.formData}
                                    API={this.props.footer && this.props.footer.API ? this.props.footer.API : this.props.API}
                                    labelLocation={this.props.footer ? this.props.footer.labelLocation : undefined}
                                    alignItemLabelsInAllGroups={this.props.footer ? this.props.footer.alignItemLabelsInAllGroups : undefined}
                                    colCount={this.props.footer ? this.props.footer.colCount : 1}
                                    colCountDefault={this.props.footer ? this.props.footer.colCountDefault : undefined}
                                    prepare={false}
                                    disabled={this.props.footer && this.props.footer.disabled !== undefined ? this.props.footer.disabled : undefined}
                                    fields={this.props.footer ? this.props.footer.fields : []}
                                    items={this.state.footerItems}
                                    postFields={this.props.footer ? this.props.footer.postFields : undefined}
                                    onFieldDataChanged={this.onFieldDataChanged}
                                    onError={this.setError}
                                />
                            </BoxItem>
                        )}
                    </Box>
                    <AntMessageBox
                        session={this.props.session}
                        ref={(ref) => {
                            this.msgBox = ref;
                        }}
                    />
                </AntPopup>
            </React.Fragment>
        );
    }
}
